module.exports = __webpack_public_path__ + "files/ed3c9856c468ad18df6729542ff0d64d.png";